/**
 * How far through creation you are.
 *
 * Three dots, not a numbered bar: the steps are one tap each, so a percentage
 * or "Schritt 2 von 3" would be more chrome than the flow it describes.
 * Completed steps stay tappable - going back is how you fix a wrong answer.
 */

interface Props {
  current: 1 | 2 | 3
  /** Highest step reached, so a step ahead is not clickable. */
  furthest: 1 | 2 | 3
  onGo: (step: 1 | 2 | 3) => void
  labels: [string, string, string]
}

export function Steps({ current, furthest, onGo, labels }: Props) {
  return (
    <nav className="steps" aria-label={labels.join(', ')}>
      {([1, 2, 3] as const).map((n) => {
        const state = n === current ? 'current' : n < furthest ? 'done' : 'todo'
        return (
          <button
            key={n}
            className="step"
            data-state={state}
            // A step you have not reached yet is not a destination.
            disabled={n > furthest}
            onClick={() => onGo(n)}
            aria-current={n === current ? 'step' : undefined}
          >
            <span className="step-dot" aria-hidden />
            <span className="step-label">{labels[n - 1]}</span>
          </button>
        )
      })}
    </nav>
  )
}
